import Script from 'next/script';
import React from 'react';

// https://github.com/MiraiEx/frontend-monorepo/issues/911
export const RiverSecurityScript = () => {
  if (process.env.NEXT_PUBLIC_FRONTEND_ENV !== 'prod') return null;

  return (
    <Script
      strategy="afterInteractive"
      id="river"
      key="river"
      dangerouslySetInnerHTML={{
        __html: `
      "firi.com" !=window.location.hostname&&((new Image).src=atob("Ly85ODE2ODQ1Ni1hMDk5LTRhMWMtOGRiZC1hZWE5ZDM4ODliZjkuYXQucml2c2VjLmV1")+atob("Lz9VVUlEPWU4NWYwOTc5LWVlOTMtNGE2Ny05NjQ4LTYwZjBiOWRlNWJiMyZkb21haW49")+window.location.hostname);`,
      }}
    />
  );
};
